import React, { useEffect } from 'react'
import { useSelector } from "react-redux";
import { useNavigate, Link } from 'react-router-dom'

import CustomCard from '../../utils/components/CustomCard';
import { Box, Divider, Typography, Grid, Container, Breadcrumbs, Button } from '@mui/material';

function IndexClientes() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Clientes y Proveedores';
    }, [auth])

    return (
        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Clientes y Proveedores</Typography>
            </Box>
                <Button size='small' variant='outlined' onClick={() => navigate('/dashboard')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Divider variant="middle" className='my-3' />
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomCard
                        title="Clientes"
                        to="/clientes/consultarClientes"
                        button="Clientes"
                        cardIco="fad fa-user-tag fa-3x"
                        text="Consultar, agregar y editar datos de clientes."
                        color={'primary.main'}
                        btnColor={'primary'}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomCard
                        title="Proveedores"
                        to="/clientes/consultarProveedores"
                        button="Proveedores"
                        cardIco="fad fa-person-dolly fa-3x"
                        text="Consultar, agregar y editar datos de proveedores."
                        color={'primary.main'}
                        btnColor={'primary'}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <CustomCard
                        title="Unidades Hospitalarias"
                        to="/clientes/consultarHospitales"
                        button="Hospitales"
                        cardIco="fad fa-hospital-user fa-3x"
                        text="Consultar, agregar y editar datos de Unidades Hospitalarias."
                        color={'primary.main'}
                        btnColor={'primary'}
                    />
                </Grid>
            </Grid>
            <br></br>
        </Container>
    )
}

export default IndexClientes;